<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.17/vue.js"></script>
<script src="https://unpkg.com/vuesax@4.0.1-alpha.16/dist/vuesax.min.js"></script>
<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/inventory/items" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateItem") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ItemCode')"
              >
                <vs-input
                  :label="$t('setup.label.ItemCode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="item.itemCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ItemDescription')"
              >
                <vs-input
                  :label="$t('setup.label.ItemDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="item.itemDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mt-2"
            >
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ItemClass") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ItemClass')"
                >
                  <v-select
                    label="item"
                    v-model="itemClass"
                    :options="itemClassData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mt-2"
            >
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Units")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Units')"
                >
                  <v-select
                    label="item"
                    v-model="item.units"
                    :options="unitData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ChargeCode")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="item"
                    v-model="item.chargeCode"
                    :options="chargesData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.ReorderLevel')"
              >
                <vs-input
                  :label="$t('setup.label.ReorderLevel')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="item.reorderLevel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.WarrantyPeriod')"
              >
                <vs-input
                  :label="$t('setup.label.WarrantyPeriod')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="item.warranty"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Currency")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Currency')"
                >
                  <v-select
                    label="item"
                    v-model="currency"
                    :options="currencyDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.DefaultPrice')"
              >
                <vs-input
                  :label="$t('setup.label.DefaultPrice')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="item.unitPrice"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="vx-col w-full" style="margin: 1.2rem 0">
                <vs-checkbox class="mt-3 font-semibold" v-model="isSelector">{{
                  $t("setup.label.IsSelector")
                }}</vs-checkbox>
              </div>
            </div>
          </div>
          <div class="vx-row w-full" v-if="isSelector">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.SelectorMenu")
                }}</small>
                <v-select
                  label="item"
                  :options="selectorDetails"
                  v-model="selector"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  ><template v-slot:option="option">{{ option.item }}</template>
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.Selector")
                }}</small>
                <vs-textarea
                  readonly
                  :placeholder="$t('setup.label.select_from_dropdown')"
                  v-model="item.selectorDescription"
                />
              </div>
            </div>
          </div>
          <div class="flex items-end px-3" style="margin-top: 20px">
            <span class="font-medium text-lg leading-none"
              >{{ $t("setup.label.VariablePrice")
              }}<span class="required"> *</span></span
            >
          </div>
          <vs-divider />
          <vs-table :data="item.itemPrices" class="w-full">
            <template slot="thead">
              <vs-th colspan="12">
                <div class="vx-row w-full">
                  <div class="vx-col w-full md:w-11/12">
                    <div class="vx-row w-full">
                      <div class="vx-col w-full md:w-1/2">
                        {{ $t("setup.label.ItemModel") }}
                      </div>
                      <div class="vx-col w-full md:w-1/2">
                        <div class="ml-6">{{ $t("setup.label.Price") }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-full md:w-1/12">
                    {{ $t("setup.label.Action") }}
                  </div>
                </div>
              </vs-th>
            </template>
            <template>
              <vs-tr>
                <vs-td colspan="12">
                  <div
                    class="vx-row w-full pb-2 pt-2"
                    v-for="(n, i) in item.itemPrices.length"
                    :key="n"
                  >
                    <div class="vx-col w-full md:w-11/12">
                      <div class="vx-row">
                        <div class="vx-col w-full md:w-1/2">
                          <vs-input
                            v-model="item.itemPrices[i].regionId"
                            :placeholder="$t('setup.label.ItemModel')"
                            class="w-full mb-2 font-semibold"
                          />
                        </div>
                        <div class="vx-col w-full md:w-1/2">
                          <vs-input
                            :placeholder="$t('setup.label.price')"
                            v-model="item.itemPrices[i].price"
                            class="w-full mb-2 font-semibold"
                            @input="validateNumberInput(i)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/12">
                      <vs-button
                        v-if="n == item.itemPrices.length"
                        color="success"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="mt-5"
                        type="border"
                        title="add"
                        size="small"
                        style="border-radius: 50%"
                        @click="addItem(i)"
                      ></vs-button>
                      <vs-button
                        v-else
                        color="warning"
                        icon-pack="feather"
                        icon="icon-x"
                        class="mt-5"
                        type="border"
                        size="small"
                        style="border-radius: 50%"
                        @click="removeItem(i)"
                      ></vs-button>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="createItems">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
const itemEmptyObj = {
  itemCode: "",
  itemClass: 0,
  chargeCode: "",
  itemDescription: "",
  itemPrices: [{ regionId: "", price: "", locale: "en" }],
  locale: "en",
  reorderLevel: "",
  unitPrice: 0,
  units: "",
  warranty: "",
  currencyId: 0,
  isSelector: false,
  selectorDescription: "",
};
export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      item: itemEmptyObj,
      // num: 1,
      itemTemplate: {},
      itemClassData: [],
      itemIds: [],
      itemPrices: [{ regionId: "", price: "", locale: "en" }],
      chargesData: [],
      unitData: [],
      currencyDatas: [],
      currencyIds: [],
      currency: "",
      itemClass: "",
      isSelector: false,
      tempPrice: 0,
      tempRegionId: "",
      itemPriceEmpty: {},
      selectorDetails: ["Item Type", "Customer Category", "City"],
      selectorDescription: [
        "select b.item_type from b_item_detail a, b_item_attribute b where a.item_model=b.id and a.serial_no='b_item_detail.serialNo'",
        "selectorClient",
        "selectorCity",
      ],
      selector: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      template: (state) => state.items.itemTemplate,
    }),
    num() {
      return this.item.itemPrices.length;
    },
    // selectorDetails() {
    //   this.item.selectorDescription = this.selector;
    // },
  },
  methods: {
    validateNumberInput(index) {
      const price = this.item.itemPrices[index].price;
      this.item.itemPrices[index].price = price.replace(/\D/g, "");
    },
    async getItemData() {
      try {
        await this.$store.dispatch("items/setItemTemplate");
        this.itemTemplate = this.template;
        for (let tempClass of this.template.itemClassData) {
          this.itemClassData.push(tempClass.value);
          this.itemIds.push(tempClass.id);
        }
        for (let tempCharge of this.template.chargesData) {
          this.chargesData.push(tempCharge.chargeCode);
        }
        for (let tempUnit of this.template.unitData) {
          this.unitData.push(tempUnit.value);
        }
        for (let tempCurrency of this.template.currencyDatas) {
          this.currencyDatas.push(
            tempCurrency.code + " --" + tempCurrency.name
          );
          this.currencyIds.push(tempCurrency.id);
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    addItem() {
      this.item.itemPrices = [
        ...this.item.itemPrices,
        { regionId: "", price: "", locale: "en" },
      ];
    },
    removeItem(i) {
      this.item.itemPrices.splice(i, 1);
    },
    async createItems() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        await this.$store.dispatch("items/createItemAction", this.item);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Created Successfully!",
          type: "success",
        });
        this.$router.push(`/inventory/items`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.item = { ...itemEmptyObj };
      this.item.itemCode = "";
      this.item.itemClass = "";
      //this.item.supplierDescription = "";
    },
    cancel() {
      this.$router.push(`/inventory/items`);
    },
  },
  watch: {
    selector(value) {
      let indx = this.selectorDetails.indexOf(value);
      this.item.selectorDescription = this.selectorDescription[indx];
    },
    currency(value) {
      let indx = this.currencyDatas.indexOf(value);
      this.item.currencyId = this.currencyIds[indx];
    },
    itemClass(value) {
      let indx = this.itemClassData.indexOf(value);
      this.item.itemClass = this.itemIds[indx];
    },
  },
  mounted() {
    this.resetForm();
    this.getItemData();
    this.itemPrices.push(this.itemPriceEmpty);
  },
};
</script>
<style scoped>
.middle {
  margin-left: auto;
  margin-right: auto;
}
</style>